import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { BaseSearchModel } from '../../../Data/Models/Common/base-search-model';
import { MaterialModule } from '../../../material.module';
import { NoteService } from './note.service';
import { Note3Component } from './note3/note3.component';
import { Notes2 } from './notes-model';
import { Note6Component } from './note6/note6.component';
import { Note7Component } from './note7/note7.component';
import { Note4Component } from './note4/note4.component';
@Component({
  selector: 'app-notesofaccounts',
  imports: [TablerIconsModule, MaterialModule, CommonModule, RouterModule, MatTabsModule, Note3Component, Note4Component, Note6Component, Note7Component, ReactiveFormsModule],
  templateUrl: './notesofaccounts.component.html',
  styleUrl: './notesofaccounts.component.scss'
})
 export class NotesofaccountsComponent {

  selectNotes: boolean = true; selectedNotes: boolean = false;

  isEditing: boolean = false; note1: boolean = true; note2: boolean = false; note3: boolean = false; note4: boolean = false; note5: boolean = false; note6: boolean = false;
  note7: boolean = false; note8: boolean = false; note9: boolean = false; note10: boolean = false; note11: boolean = false; note12: boolean = false; note13: boolean = false;
  note14: boolean = false; note15: boolean = false; note16: boolean = false; note17: boolean = false; note18: boolean = false; note19: boolean = false; note20: boolean = false;
  note21: boolean = false; note22: boolean = false; note23: boolean = false; note24: boolean = false; note25: boolean = false; note26: boolean = false; note27: boolean = false;
  note28: boolean = false; note29: boolean = false; note30: boolean = false; note31: boolean = false; note32: boolean = false; note33: boolean = false; note34: boolean = false;
  note35: boolean = false;

   FinancialNotes: any[] = [
    { id: 1, title: 'Basis of preparation', required: true, },
    { id: 2, title: 'Accounting policies', required: true },
    { id: 3, title: 'Income Analysis by Category', required: false },
    { id: 4, title: 'Government Grants', required: false },
    { id: 5, title: 'Donated Goods/Services', required: false },
    { id: 6, title: 'Expenditure Analysis', required: false },
    { id: 7, title: 'Extraordinary Items', required: false },
    { id: 8, title: 'Acting as Agent', required: false },
    { id: 9, title: 'Support Costs Allocation', required: false },
    { id: 10, title: 'Independent Examiner/Audit Fees', required: false },
    { id: 11, title: 'Staff Costs & Employee Information', required: false },
    { id: 12, title: 'Pension Disclosures', required: false },
    { id: 13, title: 'Grantmaking Details', required: false },
    { id: 14, title: 'Tangible Fixed Assets', required: false },
    { id: 15, title: 'Intangible Assets', required: false },
    { id: 16, title: 'Heritage Assets', required: false },
    { id: 17, title: 'Investment Assets', required: false },
    { id: 18, title: 'Stocks', required: false },
    { id: 19, title: 'Debtors & Prepayments', required: false },
    { id: 20, title: 'Creditors & Accruals', required: false },
    { id: 21, title: 'Provisions & Contingent Liabilities', required: false },
    { id: 22, title: 'Financial Instruments', required: false },
    { id: 23, title: 'Contingent Assets & Liabilities', required: false },
    { id: 24, title: 'Cash at Bank and in Hand', required: false },
    { id: 25, title: 'Fair Value Disclosures', required: false },
    { id: 26, title: 'Post-Balance Sheet Events', required: false },
    { id: 27, title: 'Fund Movements & Reconciliation', required: false },
    { id: 28, title: 'Trustee & Related Party Transactions', required: false },
    { id: 29, title: 'Other Disclosures (custom/free-form)', required: false }
  ];

  textContent: string = "The financial statements have been prepared in accordance with Accounting and Reporting by Charities: Statement of Recommended Practice applicable to charities preparing their accounts in accordance with the Financial Reporting Standard applicable in the UK and Republic of Ireland (FRS 102) (effective 1 January 2019) - (Charities SORP (FRS 102)), the Financial Reporting Standard applicable in the UK and Republic of Ireland (FRS 102) and the Companies Act 2006.";

  isChecked = false; isChecked2 = false; isChecked3 = false; isChecked4 = false; isChecked5 = false; isChecked6 = false; isChecked7 = false; isChecked8 = false;
  isActive: boolean = false; isActive2: boolean = false; isActive3: boolean = false; isActive4: boolean = false; isActive5: boolean = false; isActive6: boolean = false;
  isActive7: boolean = false; isActive8: boolean = false; isActive9: boolean = false; isActive10: boolean = false; isActive11: boolean = false; isActive12: boolean = false;
  isActive13: boolean = false; isActive14: boolean = false; isActive15: boolean = false; isActive16: boolean = false; isActive17: boolean = false; isActive18: boolean = false;
  isActive19: boolean = false; isActive20: boolean = false; isActive21: boolean = false; isActive22: boolean = false; isActive23: boolean = false; isActive24: boolean = false;
  isActive25: boolean = false; isActive26: boolean = false; isActive27: boolean = false; isActive28: boolean = false; isActive29: boolean = false; isActive30: boolean = false;
  isActive31: boolean = false; isActive32: boolean = false; isActive33: boolean = false; isActive34: boolean = false; isActive35: boolean = false;
    CurrentNote: string;
    CurrentNoteisactive: string;
    Addnotes2form: FormGroup<any>;
  ChangeRoute() { }
  constructor(private router: Router, private Note_Service: NoteService) {
    this.Createnotes2()
  }
  
  Createnotes2() {
    debugger
    this.Addnotes2form= new FormGroup({
      Notes2ID: new FormControl(null),
      Basis_of_Preparation: new FormControl(`These accounts have been prepared under the historical cost convention with items recognised at cost or transaction value unless otherwise stated in the relevant note(s) to these accounts. The accounts have been prepared in accordance with: the Statement of Recommended Practice: Accounting and Reporting by Charities preparing their accounts in accordance with the Financial Reporting Standard applicable in the UK and Republic of Ireland (FRS 102) issued on 16 July 2014 and with the Financial Reporting Standard applicable in the United Kingdom and Republic of Ireland (FRS 102) and with the Charities Act 2011. The charity constitutes a public benefit entity as defined by FRS 102.`),
      Going_concern: new FormControl(`The trustees consider that there are no material uncertainties about the charity's ability to continue as a going concern.`),
      Changeofaccountingpolicy: new FormControl(null),
      Changestoaccountingestimates: new FormControl(null),
      Materialprioryearerrors: new FormControl(null),
      Reconciliationaccountingpractice: new FormControl(null),
      Recognitionofincome: new FormControl(`These are included in the Statement of Financial Activities (SoFA) when: the charity becomes entitled to the resources; it is more likely than not that the trustees will receive the resources; the monetary value can be measured with sufficient reliability.`),
      Offsetting: new FormControl(`There has been no offsetting of assets and liabilities, or income and expenses,unless required or permitted by the FRS 102 SORP or FRS 102.`),
      Grantsanddonations: new FormControl(`Grants and donations are only included in the SoFA when the general income recognition criteria are met (5.10 to 5.12 FRS 102 SORP). In the case of performance related grants, income must only be recognised to the extent that the charity has provided the specified goods or services as entitlement to the grant only occurs when the performance related conditions are met (5.16 FRS 102 SORP).`),
      Legacies: new FormControl(`Legacies are included in the SOFA when receipt is probable, that is, when there has been grant of probate, the executors have established that there are sufficient assets in the estate and any conditions attached to the legacy are either within the control of the charity or have been met. `),
      Governmentgrants: new FormControl(`The charity has received government grants in the reporting period`),
      Taxreclaimsondonationsandgifts: new FormControl(`Gift Aid receivable is included in income when there is a valid declaration from the donor. Any Gift Aid amount recovered on a donation is considered to be part of that gift and is treated as an addition to the same fund as the initial donation unless the donor or the terms of the appeal have specified otherwise.`),
      incomeandperformancerelatedgrants: new FormControl(`This is only included in the SoFA once the charity has provided the related goods or services or met the performance related conditions `),
      Donatedgoods: new FormControl(`Donated goods are measured at fair value (the amount for which the asset could be exchanged) unless impractical to do so. The cost of any stock of goods donated for distribution to beneficiaries is deemed to be the fair value of those gifts at the time of their receipt and they are recognised on receipt. In the reporting period in which the stocks are distributed, they are recognised as an expense at the carrying amount of the stocks at distribution.  Donated goods for resale are measured at fair value on initial recognition, which is the expected proceeds from sale less the expected costs of sale, and recognised in �Income from other trading activities� with the corresponding stock recognised in the balance sheet. On its sale the value of stock is charged against �Income from other trading activities� and the proceeds from sale are also recognised as �Income from other trading activities�. Goods donated for on-going use by the charity are recognised as tangible fixed assets and included in the SoFA as incoming resources when receivable. Gifts in kind for use by the charity are included in the SoFA as income from donations when receivable.`),
      Donatedservicesandfacilities: new FormControl(`Donated services and facilities are included in the SOFA when received at the value of the gift to the charity provided the value of the gift can be measured reliably. Donated services and facilities that are consumed immediately are recognised as income with an equivalent amount recognised as an expense under the appropriate heading in the SOFA.`),
      Supportcosts: new FormControl(`The charity has incurred expenditure on support costs.`),
      Volunteerhelp: new FormControl(`The value of any voluntary help received is not included in the accounts but is described in the trustees� annual report.`),
      Incomefrominterestroyaltiesanddividends: new FormControl(`This is included in the accounts when receipt is probable and the amount receivable can be measured reliably.`),
      Incomefrommembershipsubscriptions: new FormControl(`Membership subscriptions received in the nature of a gift are recognised in Donations and Legacies.`),
      Settlementofinsuranceclaims: new FormControl(`Insurance claims are only included in the SoFA when the general income recognition criteria are met (5.10 to 5.12 FRS 102 SORP) and are included as an item of other income in the SoFA.`),
      Investmentgainsandlosses: new FormControl(`This includes any realised or unrealised gains or losses on the sale of investments and any gain or loss resulting from revaluing investments to market value at the end of the year.`),
      Liabilityrecognition: new FormControl(`Liabilities are recognised where it is more likely than not that there is a legal or constructive obligation committing the charity to pay out resources and the amount of the obligation can be measured with reasonable certainty.`),
      Governanceandsupportcosts: new FormControl(`Support costs have been allocated between governance costs and other support. Governance costs comprise all costs involving public accountability of the charity and its compliance with regulation and good practice. Support costs include central functions and have been allocated to activity cost categories on a basis consistent with the use of resources, eg allocating property costs by floor areas, or per capita, staff costs by the time spent and other costs by their usage.`),
      Grantswithperformanceconditions: new FormControl(`Where the charity gives a grant with conditions for its payment being a specific level of service or output to be provided, such grants are only recognised in the SoFA once the recipient of the grant has provided the specified service or output.`),
      Grantspayablewithoutperformanceconditions: new FormControl(`Where there are no conditions attaching to the grant that enables the donor charity to realistically avoid the commitment, a liability for the full funding obligation must be recognised.`),
      Redundancycost: new FormControl(`The charity made no redundancy payments during the reporting period.`),
      Deferredincome: new FormControl(`No material item of deferred income has been included in the accounts.`),
      Creditors: new FormControl(`The charity has creditors which are measured at settlement amounts less any trade discounts.`),
      Provisionsforliabilities: new FormControl(`A liability is measured on recognition at its historical cost and then subsequently measured at the best estimate of the amount required to settle the obligation at the reporting date.`),
      Basicfinancialinstruments: new FormControl(`The charity accounts for basic financial instruments on initial recognition as per paragraph 10.7 FRS 102 SORP. Subsequent measurement is as per paragraphs 11.17 to 11.19, FRS 102 SORP.`),
      Tangiblefixedassets: new FormControl(`These are capitalised if they can be used for more than one year, and cost at least They are valued at cost. The depreciation rates and methods used are disclosed.`),
      Intangiblefixedassets: new FormControl(`The charity has intangible fixed assets, that is, non-monetary assets that do not have physical substance but are identifiable and are controlled by the charity through custody or legal rights. The amortisation rates and methods used are disclosed. They are valued at cost.`),
      Heritageassets: new FormControl(`The charity has heritage assets, that is, non-monetary assets with historic, artistic, scientific, technological, geophysical or environmental qualities that are held and maintained principally for their contribution to knowledge and culture. The depreciation rates and methods used are disclosed. They are valued at cost.`),
      Investments: new FormControl(`Fixed asset investments in quoted shares, traded bonds and similar investments are valued at initially at cost and subsequently at fair value (their market value) at the year end. The same treatment is applied to unlisted investments unless fair value cannot be measured reliably in which case it is measured at cost less impairment. Investments held for resale or pending their sale and cash and cash equivalents with a maturity date of less than 1 year are treated as current asset investments.`),
      Stocksandworkinprogress: new FormControl(`Stocks held for sale as part of non-charitable trade are measured at the lower or cost or net realisable value. Goods or services provided as part of a charitable activity are measured at net realisable value based on the service potential provided by items of stock. Work in progress is valued at cost less any foreseeable loss that is likely to occur on the contract.`),
      Debtors: new FormControl(`Debtors (including trade debtors and loans receivable) are measured on initial recognition at settlement amount after any trade discounts or amount advanced by the charity. Subsequently, they are measured at the cash or other consideration expected to be received.`),
      Currentassetinvestments: new FormControl(`The charity has investments which it holds for resale or pending their sale and cash and cash equivalents with a maturity date less than one year. These include cash on deposit and cash equivalents with a maturity date of less than one year held for investment purposes rather than to meet short term cash commitments as they fall due. They are valued at fair value except where they qualify as basic financial instruments.`),
      CharityID: new FormControl(null),
      FinancialPeriodsID: new FormControl(null),
      CentralUserId: new FormControl(null),
      UserId: new FormControl(null)
    })
  }

  save() {
    debugger
    var Addnotes = this.Addnotes2form.getRawValue();
    this.Note_Service.SaveNotes2(Addnotes).subscribe((data: BaseSearchModel<string>) => {
      debugger
      

    })
  
}

  toggleEdit() {
    this.isEditing = !this.isEditing; 
  }
  backToSelectNotes() {
    this.selectNotes = true;
    this.selectedNotes =false;
  }
  continueSelectedNotes() {debugger
    this.selectNotes = false;
    this.selectedNotes = true;
  }

  displayedColumns: string[] = ['Fund balances as previously stated', 'Start of period', 'End of period'];
  data: any[] = [
    { type: 'data', Description: 'Turnover', IncomeExpenses: '', Disallowable: '' },
  ];

  displayedColumns2: string[] = ['Net income/(expenditure) as previously stated', 'End of period'];
  data2: any[] = [
    { type: 'data', Description: 'Turnover', IncomeExpenses: '', Disallowable: '' },
  ];

  displayedColumns3: string[] = ['Name', 'Rate', 'Action'];
  assetsTangible: any[] = [
    { name: 'data', rate: '20'},
  ];

  displayedColumns4: string[] = ['Name', 'Rate', 'Action'];
  assetsInTangible: any[] = [
    { type: 'data', Description: 'Turnover', IncomeExpenses: '', Disallowable: '' },
  ];

  displayedColumnsDonations: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  donations: any[] = [
    { type: 'General grants provided by government / other charities' },
    { type: 'Donations and gifts - General' },
    { type: 'Gift Aid' },
    { type: 'Donations and gifts - Covid 19 Specific' },
    { type: 'Legacies' },
    { type: 'Membership subscriptions and sponsorships which are in substance donations' },
    { type: 'Donated goods, facilities and services' },
    { type: 'Other' },
  ];

  displayedColumnsCharitable: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  Charitable: any[] = [
    { type: 'General grants provided by government / other charities' },
  ];

  displayedColumnsOtherCharitable: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  OtherCharitable: any[] = [
    { type: 'General grants provided by government / other charities' },
  ];

  displayedColumnsInvestment: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  Investment: any[] = [
    { type: 'Interest income' },
    { type: 'Dividend income' },
    { type: 'Rent and leasing income' },
    { type: 'Other' },
  ];

  displayedColumnsmaterial: string[] = ['Analysis', 'Unrestricted', 'Restricted', 'Endowment', 'Total', 'Prior year'];
  material: any[] = [
    { type: 'General grants provided by government / other charities' },
  ];

  changetoNoteTab1() {
    this.note1 = true;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = true;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab2() {
    this.note1 = false;
    this.note2 = true;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = true;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab3() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = true;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = true;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab4() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = true;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = true;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab5() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = true;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = true;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab6() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = true;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = true;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab7() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = true;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = true;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab8() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = true;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = true;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab9() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = true;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = true;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab10() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = true;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = true;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  ChangeIsActiveFromChild(isactive: any) {
 //   alert(isactive)
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
    (this as any)[isactive] = true;}
 public changetoNoteTab11() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = true;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = true;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab12() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = true;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = true;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  changetoNoteTab13() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = true;
    this.note14 = false;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = true;
    this.isActive14 = false;
    this.isActive15 = false;
  }
  ChangeNoteFromChild() {


  }
  ClickSelectedNote(isactive: string,note: string ): void {debugger
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = false;
    this.note16 = false;
    this.note17 = false;
    this.note18 = false;
    this.note19 = false;
    this.note20 = false;
    this.note21 = false;
    this.note22 = false;
    this.note23 = false;
    this.note24 = false;
    this.note25 = false;
    this.note26 = false;
    this.note27 = false;
    this.note28 = false;
    this.note29 = false;
    this.note30 = false;
    this.note31 = false;
    this.note32 = false;
    this.note33 = false;
    this.note34 = false;
    this.note35 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = false;
    this.isActive16 = false;
    this.isActive17 = false;
    this.isActive18 = false;
    this.isActive19 = false;
    this.isActive20 = false;
    this.isActive21 = false;
    this.isActive22 = false;
    this.isActive23 = false;
    this.isActive24 = false;
    this.isActive25 = false;
    this.isActive26 = false;
    this.isActive27 = false;
    this.isActive28 = false;
    this.isActive29 = false;
    this.isActive30 = false;
    this.isActive31 = false;
    this.isActive32 = false;
    this.isActive33 = false;
    this.isActive34 = false;
    this.isActive35 = false;
    (this as any)[note] = true;
    (this as any)[isactive] = true;
    this.CurrentNote = note
    this.CurrentNoteisactive = isactive
  }
  SaveAndNext() {
    debugger
    this.Addnotes2form.getRawValue()
    var currentNoteNumber=this.CurrentNote.split('note')[1]
    var currentNoteisactive = this.CurrentNoteisactive.split('isActive')[1]
    var NextNoteNumvber = `note${+currentNoteNumber +1}`
    var NextNoteisactive = `isActive${+currentNoteisactive + 1}`
    this.ClickSelectedNote(NextNoteisactive, NextNoteNumvber)
    this.save();
  }
  changetoNoteTab14() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false; 
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = true;
    this.note15 = false;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = true;
    this.isActive15 = false;
  }
  changetoNoteTab15() {
    this.note1 = false;
    this.note2 = false;
    this.note3 = false;
    this.note4 = false;
    this.note5 = false;
    this.note6 = false;
    this.note7 = false;
    this.note8 = false;
    this.note9 = false;
    this.note10 = false;
    this.note11 = false;
    this.note12 = false;
    this.note13 = false;
    this.note14 = false;
    this.note15 = true;
    this.note16 = true;
    this.isActive = false;
    this.isActive2 = false;
    this.isActive3 = false;
    this.isActive4 = false;
    this.isActive5 = false;
    this.isActive6 = false;
    this.isActive7 = false;
    this.isActive8 = false;
    this.isActive9 = false;
    this.isActive10 = false;
    this.isActive11 = false;
    this.isActive12 = false;
    this.isActive13 = false;
    this.isActive14 = false;
    this.isActive15 = true;
    this.isActive16 = true;
  }
 

  noteTitle = 'pavan kalyan';
  handleChildClick(data: string) {
   // alert(data);
    this.changetoNoteTab8();
    // Perform actions in the parent
  }
}


export interface FinancialNote {
  id: number;
  title: string;
  required: boolean;
  noteNumber: string;
  note?: string;
  IsSelected?: boolean;
}

export const FinancialNotes: FinancialNote[] = [
  { id: 1, title: 'Basis of preparation', required: true, IsSelected: true, noteNumber: 'Note 1' },
  { id: 2, title: 'Accounting policies', required: true, IsSelected: true, noteNumber: 'Note 2' },
  { id: 3, title: 'Income Analysis by Category', required: false, IsSelected: true, noteNumber: 'Note 3' },
  { id: 4, title: 'Government Grants', required: false, IsSelected: true, noteNumber: 'Note 4' },
  { id: 5, title: 'Donated Goods/Services', required: false, IsSelected: true, noteNumber: 'Note 5' },
  { id: 6, title: 'Expenditure Analysis', required: false, IsSelected: true, noteNumber: 'Note 6' },
  { id: 7, title: 'Extraordinary Items', required: false, IsSelected: true, noteNumber: 'Note 7' },
  { id: 8, title: 'Acting as Agent', required: false,  IsSelected: true,noteNumber: 'Note 8' },
  { id: 9, title: 'Support Costs Allocation', required: false,  IsSelected: true,noteNumber: 'Note 9' },
  { id: 10, title: 'Independent Examiner/Audit Fees', required: false,  IsSelected: true,noteNumber: 'Note 10' },
  { id: 11, title: 'Staff Costs & Employee Information', required: false, IsSelected: true, noteNumber: 'Note 11' },
  { id: 12, title: 'Pension Disclosures', required: false, IsSelected: true, noteNumber: 'Note 12' },
  { id: 13, title: 'Grantmaking Details', required: false, IsSelected: true, noteNumber: 'Note 13' },
  { id: 14, title: 'Tangible Fixed Assets', required: false,  IsSelected: true,noteNumber: 'Note 14' },
  { id: 15, title: 'Intangible Assets', required: false,  IsSelected: true,noteNumber: 'Note 15' },
  { id: 16, title: 'Heritage Assets', required: false,  IsSelected: true,noteNumber: 'Note 16' },
  { id: 17, title: 'Investment Assets', required: false,  IsSelected: true,noteNumber: 'Note 17' },
  { id: 18, title: 'Stocks', required: false, IsSelected: true, noteNumber: 'Note 18' },
  { id: 19, title: 'Debtors & Prepayments', required: false, IsSelected: true, noteNumber: 'Note 19' },
  { id: 20, title: 'Creditors & Accruals', required: false, IsSelected: true, noteNumber: 'Note 20' },
  { id: 21, title: 'Provisions & Contingent Liabilities', required: false, IsSelected: true, noteNumber: 'Note 21' },
  { id: 22, title: 'Financial Instruments', required: false, IsSelected: true, noteNumber: 'Note 22' },
  { id: 23, title: 'Contingent Assets & Liabilities', required: false, IsSelected: true, noteNumber: 'Note 23' },
  { id: 24, title: 'Cash at Bank and in Hand', required: false, IsSelected: true, noteNumber: 'Note 24' },
  { id: 25, title: 'Fair Value Disclosures', required: false, IsSelected: true, noteNumber: 'Note 25' },
  { id: 26, title: 'Post-Balance Sheet Events', required: false, IsSelected: true, noteNumber: 'Note 26' },
  { id: 27, title: 'Fund Movements & Reconciliation', required: false, IsSelected: true, noteNumber: 'Note 27' },
  { id: 28, title: 'Trustee & Related Party Transactions', required: false, IsSelected: true, noteNumber: 'Note 28' },
  { id: 29, title: 'Other Disclosures (custom/free-form)', required: false, IsSelected: true, noteNumber: 'Note 29' }
];
